import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { FlatDetail } from 'types/api'
import { BaseParams } from 'types/utils'

export const flatsQueryKey = ['flats']

export function useFlatsDetail({ id }: BaseParams<{}>) {
  async function getFlats() {
    const response = await apiClient.get<FlatDetail>(SNA_PREFIX + `flats/${id}`)

    return response.data
  }

  return useQuery({
    queryFn: getFlats,
    enabled: !!id,
    queryKey: [...flatsQueryKey, id]
  })
}
